import React, { useState } from 'react';
import { isNil } from 'lodash';
import { Card, Spin } from 'antd';
import { useQuery } from 'react-query';
import { FormInstance } from 'antd/lib/form';
import {PlusOutlined} from '@ant-design/icons';
import DataGrid, { formatDate } from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  getScoringFileList,
  ScoringViewResponse,
} from 'services/scoring';
import ModalController from 'components/ModalController';
import AddFinStatement from './AddFinStatementModal';
import ScoringModal from 'pages/Scoring/ScoringDetail/ScoringModal';
import ButtonOperation from 'components/ButtonOperation';
import GetLabel from 'DisplayFramework/components/GetLabel';

type FinancialStatementCardProps = {
  form: FormInstance;
  objectid?: String;
  showAsModal?: boolean;
  refetchTab?: boolean;
  tpname?: string;
  tpreference?: string;
  
};

const Analysis = ({
  objectid,
  form,
  showAsModal,
  refetchTab,
  tpname,
  tpreference,
}: FinancialStatementCardProps) => {
  return (
    <Card
      style={{
        boxShadow:
          'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
      }}
      title={<GetLabel label="finStatement" style={{fontWeight:'bold',paddingLeft:15}} />}
      bordered
    >
      <ScoringTable
        objectid={Number(objectid)}
        form={form}
        showAsModal={showAsModal}
        tpname={tpname}
        tpreference={tpreference}
        refetchTab={refetchTab}
      />
    </Card>
  );
};

export default Analysis;

type ScoringTableProps = {
  objectid?: number;
  form: FormInstance;
  showAsModal?: boolean;
  tpname?: string;
  tpreference?: string;
  refetchTab?: boolean;

};

const ScoringTable = ({
  objectid,
  form,
  showAsModal,
  tpname,
  tpreference,
  refetchTab,
}: ScoringTableProps) => {
  const { data, isFetching, refetch } = useQuery(
    ['getScoringFileList', { objectid }],
    () =>
      getScoringFileList({
        objectid: objectid ? objectid : -1,
        objecttype: 'THIRDPARTY',
      }).then((res) => res.list || []),
    {
      enabled: !isNil(objectid),
    }
  );
  const [isloading, setIsloading] = useState<boolean>(false);


  const columns: DataGridColDef<ScoringViewResponse>[] = [
    {
      comcode: 'scoring.scoreference',
      dataIndex: 'scoreference',
      width: 100,
      render: (scoreference, record) => (
        <ModalController>
          {({ setVisible, visible }) => (
            <>
              <a onClick={() => setVisible(true)}>
                {scoreference} 
              </a>
              <ScoringModal
                showAsModal={showAsModal}
                fromtp
                scoid={record.scoid}
                visible={visible}
                onCancel={() => setVisible(false)}
                onSuccess={() => setVisible(false)}
              />
            </>
          )}
        </ModalController>
      ),
    },

    {
      comcode: 'scoring.scogridlabel',
      dataIndex: 'scogridlabel',
      width: 100,
      render: (scogridlabel, record) => (
        <ModalController>
          {({ setVisible, visible }) => (
            <>
              <a onClick={() => setVisible(true)}>{scogridlabel}</a>
              <ScoringModal
                showAsModal={showAsModal}
                fromtp
                scoid={record.scoid}
                visible={visible}
                onCancel={() => setVisible(false)}
                onSuccess={() => setVisible(false)}
              />
            </>
          )}
        </ModalController>
      ),
    },

    {
      comcode: 'scoring.scodate',
      dataIndex: 'scodate',
      width: 100,
      valueFormatter: formatDate,
    },
    {
      comcode: 'scoring.referenceyear',
      dataIndex: 'referenceyear',
      width: 100,
    },
  ];

  return (
    <Card bordered>
      <Spin spinning={isFetching||isloading} tip="Loading..." >
      <DataGrid
        columns={columns}
        dataSource={data}
        rowKey={({ scoid }) => scoid}
        hideFilters
        extraActions={
          <ModalController>
            {({ setVisible, visible }) => (
              <>
                {!showAsModal && (
                  <ButtonOperation
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                        setVisible(true);
                      }}
                    comcode="add"
                  />
                )}
                <AddFinStatement
                  object="THIRDPARTY"
                  objectid={Number(objectid)}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  refetch={refetch}
                  isFetching={isFetching}
                  form={form}
                />
              </>
            )}
          </ModalController>
        }
      />
      </Spin>
    </Card>
  );
};
